import { render, staticRenderFns } from "./complaint_manage.vue?vue&type=template&id=23afb350&scoped=true&"
import script from "./complaint_manage.vue?vue&type=script&lang=js&"
export * from "./complaint_manage.vue?vue&type=script&lang=js&"
import style0 from "./complaint_manage.vue?vue&type=style&index=0&id=23afb350&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afb350",
  null
  
)

export default component.exports